import { AccidentQuestionActions } from "../action";

export type AccidentQuestionResponse = "Yes" | "No";

type AccidentQuestionState = {
  customerResponse: AccidentQuestionResponse;
}

const initialState: AccidentQuestionState = {
  customerResponse: undefined,
};

export const AccidentQuestionReducer = (state: AccidentQuestionState = initialState, action: AccidentQuestionActions): AccidentQuestionState => {
  switch (action.type) {
    case "UPDATE_ACCIDENT_QUESTIONS":
      return { ...state, customerResponse: action.payload };
    case "REFRESH_REDUCERS":
      return { ...initialState }
    default:
      return state;
  }
}